export class LookupDataValidation {
  rangeToBeDeleted?: {
    startRow: number;
    startCol: number;
    endRow: number;
    endCol: number;
  } = null;
  public constructor(
    public isValidTable: boolean = true,
    public invalidMnemonicId: number = null,
    public validationMessages: string[] = []
  ) {}
}
